import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { LoadingService } from "src/app/utils/loading/loading.service";
import { AcordarService } from "src/app/services/acordar.service";

@Component({
  selector: "app-main-page-acordar",
  templateUrl: "./main-page-acordar.component.html",
  styleUrls: ["./main-page-acordar.component.scss"],
})
export class MainPageAcordarComponent implements OnInit {
  activeLink: BehaviorSubject<any> = new BehaviorSubject(null);
  indicadores: BehaviorSubject<Array<any>> = new BehaviorSubject([]);

  routes = [
    { titulo: "Acuerdos", ruta: "acuerdos-nacionales", alt: "" },
    { titulo: "Ofertas", ruta: "oferta-productos", alt: "" },
    { titulo: "Contrataciones", ruta: "contrataciones", alt: "" },
  ];

  showFooter: BehaviorSubject<any> = new BehaviorSubject(false);
  imgUrl: string;

  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private acordarService: AcordarService
  ) {}

  ngOnInit() {
    this.routes.map((route) => {
      if (this.router.url === "/" + route.ruta) {
        this.clickHandler(route.titulo);
      } else if (this.router.url.includes("/" + route.ruta)) {
        this.clickHandler(route.titulo);
      }
    });
    this.loadingService.isLoading.subscribe((rta) => {
      this.showFooter.next(rta);
    });
    this.acordarService.getBuscarContrataciones(1).subscribe((rta) => {
      this.indicadores.next(rta.result.indicadores);
    });
    this.changeImage();
  }

  changeImage() {
    if (window.innerWidth <= 590) {
      this.imgUrl = "../../../assets/images/banner-acordar-mobile.png";
    } else {
      this.imgUrl = "../../../assets/images/banner-acordar.png";
    }
  }
  clickHandler(activeLink) {
    this.activeLink.next(activeLink);
  }
  mapAhorro(value) {
    return Math.abs(Math.round(value));
  }
}
